import React, { useState, useEffect, useCallback } from 'react'

// redux
import { connect } from 'react-redux'

// bootstrap
import {
    Container
} from 'react-bootstrap'

// categories styles
import "./styles/categories-styles.scss"

// icons : feather
import FeatherIcon from 'feather-icons-react';

// formik
import {
    useFormik, //hook for functonal components
} from 'formik'

// yup
import * as Yup from 'yup'

// react toastify
import { toast } from 'react-toastify';

// custom hooks
import useQuery from 'utlis/CustomHooks/useQueryHook'

// react router
import { useHistory } from 'react-router-dom'

// APIs
import {
    getCategoriesTree,
    getCategoryDetails,
    cancelGetCategoryDetailsApi,
    addCategory,
    editCategory,
    deleteCategory,

    saveCategoryImageApi
} from 'utlis/Apis/Categories_API'

// includes
import CategoriesLeftBar from './includes/CategoriesLeftBar'
import CategoriesDataView from './includes/CategoriesDataView'

// actions
import { setGlobalLoading } from 'redux/actions/actionCommon'

// app messages
import {
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE__NAME,
    CATEGORY_UPDATED_SUCCESSFULLY,
    ERROR_WHILE_UPDATING_CATEGORY,
    CATEGORY_ADDED_SUCCESSFULLY,
    ERROR_WHILE_CREATING_CATEGORY,
    ERROR_WHILE_GETTING_CATEGORY_DETAILS,
    CATEGORY_DELETED_SUCCESSFULLY,
    ERROR_WHILE_DELETING_CATEGORY,
    CONFIRMATION_BEFORE_DELETING_CATEGORY
} from 'utlis/AppMessages/AppMessages'
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl';

function Categories(props) {
    // props
    const {
        authState
    } = props

    // store url
    const [storeUrl] = useStoreUrl()

    // states
    const [categories, setCategories] = useState([])
    const [categoriesLoading, setCategoriesLoading] = useState(false)
    const categoriesLoadingIndicator = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

    const [selectedCategory, setSelectedCategory] = useState("")
    const [parentCategoryId, setParentCategoryId] = useState("")

    const [categoriesPageLoading, setCategoriesPageLoading] = useState(false)

    const [categoryBtnLoading, setCategoryBtnLoading] = useState(false)
    const [categorySubmitBtnDisabled, setCategorySubmitBtnDisabled] = useState(false)

    const [currentCategoryView, setCurrentCategoryView] = useState("create")

    const [leftBarExpandedCategories, setLeftBarExpandedCategories] = useState([])

    const [categoryImage, setCategoryImage] = useState("")
    const [currentCategoryImage, setCurrentCategoryImage] = useState(null)
    const [isImageDeleted, setIsImageDeleted] = useState(false)
    // consts
    const history = useHistory()
    const query = useQuery();
    const urlCatId = query.get('category')
    const urlMode = query.get('mode')

    // initial form values
    const initialCreateFormValues = {
        categoryName: "",
        status: "1",
        description: "",
        metaTitle: "",
        metaKeyword: "",
        metaDescription: "",
    }

    // handle form validations
    const createFormValidationSchema = Yup.object({
        categoryName: Yup.string().required('This field is required'),
        status: Yup.string(),
        description: Yup.string(),
        metaTitle: Yup.string(),
        metaKeyword: Yup.string(),
        metaDescription: Yup.string(),
    })

    // get categories list
    const getCategoriesList = () => {
        // enable categories list loading
        setCategoriesLoading(true)

        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        // getting categories tree
        getCategoriesTree(headers).then(res => {
            // disabling categories list loading
            setCategoriesLoading(false)

            const catsData = res.data

            // if request is success
            if (catsData.success) {
                // scrolling the window to top
                window.scrollTo(0, 0)

                // settings categories
                setCategories(catsData.data)

                // reset formik form
                formik.resetForm()
            }

            // if request is not succeed
            if (catsData.error) {
                console.log(ERROR_WHILE_CREATING_CATEGORY, res)

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(ERROR_WHILE_CREATING_CATEGORY, {
                    autoClose: 2500,
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getCategoriesTree `, err.message)

            // dismissing all the previous toasts first
            toast.dismiss();

            // showing the error message
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    // disabling categories list loading
                    setCategoriesLoading(false)
                }
            })
        })
    }

    // getting categories list
    useEffect(() => {
        // enable categories list loading
        setCategoriesLoading(true)


        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        // getting categories tree
        getCategoriesTree(headers).then(res => {
            // disabling categories list loading
            setCategoriesLoading(false)

            const catsData = res.data

            // if request is success
            if (catsData.success) {
                // scrolling the window to top
                window.scrollTo(0, 0)

                // settings categories
                setCategories(catsData.data)
            }

            // if request is not succeed
            if (catsData.error) {
                console.log(ERROR_WHILE_CREATING_CATEGORY, res)

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(ERROR_WHILE_CREATING_CATEGORY, {
                    autoClose: 2500,
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getCategoriesTree `, err.message)


            // dismissing all the previous toasts first
            toast.dismiss();

            // showing the error message
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    // disabling categories list loading
                    setCategoriesLoading(false)
                }
            })
        })
    }, [authState])

    const getCategoryDetailsFunc = useCallback(() => {
        if (urlCatId) {
            // enabling loading for the category page
            setCategoriesPageLoading(true)

            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            // getting single category details
            getCategoryDetails(headers, urlCatId).then(res => {
                const category = res.data

                // disabling loading for the category page
                setCategoriesPageLoading(false)
                // enabling the button and disabling loading
                setCategoryBtnLoading(false)
                setCategorySubmitBtnDisabled(false)

                // scrolling the window to top
                window.scrollTo(0, 0)

                // if request is success
                if (category.success) {
                    const catData = category.data

                    // setting the fields values
                    formik.setFieldValue("categoryName", catData?.category_name?.toString() ?? "")
                    formik.setFieldValue("status", catData?.status?.toString() ?? "")
                    formik.setFieldValue("description", catData?.description?.toString() ?? "")
                    formik.setFieldValue("metaTitle", catData?.meta_title?.toString() ?? "")
                    formik.setFieldValue("metaKeyword", catData?.meta_keywords?.toString() ?? "")
                    formik.setFieldValue("metaDescription", catData?.meta_description?.toString() ?? "")

                    setCurrentCategoryImage(null) // resseting selected image
                    setCategoryImage(catData?.image ?? "") // setting current image

                    setParentCategoryId(catData?.parent_id.toString() ?? "") // setting parent id
                }

                // if request is not succeed
                if (category.error) {
                    console.log(ERROR_WHILE_GETTING_CATEGORY_DETAILS, res)

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(ERROR_WHILE_GETTING_CATEGORY_DETAILS, {
                        autoClose: 2500,
                        onClick: () => {
                            // enabling the button and disabling loading
                            setCategoryBtnLoading(false)
                            setCategorySubmitBtnDisabled(false)
                        }
                    })
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} getCategories `, err.message)

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // disabling loading for the category page
                        setCategoriesPageLoading(false)
                    }
                })
            })
        }
    }, [authState, urlCatId])

    // getting categories data
    useEffect(() => {
        // if edit keyword exists in the url
        if (urlCatId) {
            if (urlMode === "edit" || urlMode === "editSubCat") { // if mode is edit and edit sub categories
                // canceling get categories api
                cancelGetCategoryDetailsApi && cancelGetCategoryDetailsApi()

                // setting category view name
                setCurrentCategoryView(urlMode)
            }

            // setting selected category id
            setSelectedCategory(urlCatId.toString())
        }

    }, [urlCatId, urlMode])

    // getting category details
    useEffect(() => {
        getCategoryDetailsFunc()
    }, [getCategoryDetailsFunc])

    // handle form submmision
    const onCreateFormSubmit = values => {
        if (values) {
            // // enabling global loading
            setGlobalLoading(true)

            // // disabling the button and enabling loading
            setCategoryBtnLoading(true)
            setCategorySubmitBtnDisabled(true)

            // if current view is create category
            if (currentCategoryView === "create") {
                // saving the data in the database
                const dataToBeSaved = {
                    category_name: values.categoryName,
                    parent_id: parentCategoryId,
                    status: values.status,
                    description: values.description,
                    meta_title: values.metaTitle,
                    meta_keywords: values.metaKeyword,
                    meta_description: values.metaDescription,
                }

                // calling function to create new category
                saveNewCategory(dataToBeSaved)
            }

            // if current view is create category and it is for a sub category
            if (currentCategoryView === "createSubCat") {
                // saving the data in the database
                const dataToBeSaved = {
                    category_name: values.categoryName,
                    parent_id: parentCategoryId,
                    status: values.status,
                    description: values.description,
                    meta_title: values.metaTitle,
                    meta_keywords: values.metaKeyword,
                    meta_description: values.metaDescription,
                }

                // calling function to create new category
                saveNewCategory(dataToBeSaved)
            }

            // if current view is edit category
            if (currentCategoryView === "edit") {
                // saving the data in the database
                const dataToBeSaved = {
                    category_id: parseInt(selectedCategory),
                    parent_id: parentCategoryId,
                    category_name: values.categoryName,
                    status: values.status,
                    description: values.description,
                    meta_title: values.metaTitle,
                    meta_keywords: values.metaKeyword,
                    meta_description: values.metaDescription,
                }

                // calling function to update category
                updateCategory(dataToBeSaved)
            }

            // if current view is edit sub category
            if (currentCategoryView === "editSubCat") {
                // saving the data in the database
                const dataToBeSaved = {
                    category_id: parseInt(selectedCategory),
                    parent_id: parentCategoryId,
                    category_name: values.categoryName,
                    status: values.status,
                    description: values.description,
                    meta_title: values.metaTitle,
                    meta_keywords: values.metaKeyword,
                    meta_description: values.metaDescription,
                }

                // calling function to update category
                updateCategory(dataToBeSaved)
            }
        }
    }

    // useEffect(() => {
    //     console.log("currentCategoryImage ", currentCategoryImage);
    //     console.log("categoryId ", parseInt(selectedCategory));
    // }, [currentCategoryImage, selectedCategory])

    // saving a new category
    const saveNewCategory = (dataToBeSaved) => {
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        // saving data
        addCategory(headers, dataToBeSaved).then(res => {
            // disabling global loading
            setGlobalLoading(false)

            // enabling the button and disabling loading
            setCategoryBtnLoading(false)
            setCategorySubmitBtnDisabled(false)

            const addingData = res.data

            console.log("addingData ", addingData);

            // if request is success
            if (addingData.success) {
                if (currentCategoryImage !== null && currentCategoryImage?.value) { // if user has selected any image
                    // data to be saved
                    const dataToBeSaved = {
                        categoryId: addingData?.category_id,
                        image: currentCategoryImage.value,
                    }

                    const headers = {
                        "Authorization": `Bearer ${authState.commonToken}`,
                        "Api-Token": authState.apiToken,
                        "Access-Token": "",
                        // "Store-Id": authState.storeId,
                    }
                    // network request
                    saveCategoryImageApi(headers, dataToBeSaved).then(res => {
                        // disabling the button and disabling loading
                        setCategoryBtnLoading(false)
                        setCategorySubmitBtnDisabled(false)

                        // disabling global loading
                        setGlobalLoading(false)

                        const resData = res.data

                        // if delete succesfully
                        if (resData.success) {
                            // dismissing all the previous toasts first
                            toast.dismiss();

                            // showing the error message
                            toast.success(CATEGORY_ADDED_SUCCESSFULLY, {
                                autoClose: 2000
                            })

                            // getting updated categories
                            getCategoriesList()

                            // if current view is create category and it is for a sub category
                            if (currentCategoryView === "createSubCat" && selectedCategory?.length) {
                                //changing url
                                history.push(storeUrl + "/catalog/categories?category=" + selectedCategory + "&mode=edit")
                            }
                        }

                        // if some error while deleting
                        if (resData.error) {
                            // dismissing all the previous toasts first
                            toast.dismiss();

                            // showing the error message
                            toast.error(resData.message ?? UNKNOWN_ERROR_OCCURED, {
                                autoClose: 2500,
                            })
                        }

                    }).catch(err => {
                        console.log(`${ERROR_WHILE__NAME} saveCategoryImageApi `, err.message)

                        // dismissing all the previous toasts first
                        toast.dismiss();

                        // showing the error message
                        toast.error(UNKNOWN_ERROR_OCCURED, {
                            autoClose: 2500,
                            onClose: () => {
                                // disabling the button and disabling loading
                                setCategoryBtnLoading(false)
                                setCategorySubmitBtnDisabled(false)

                                // disabling global loading
                                setGlobalLoading(false)
                            }
                        })
                    })
                } else { // if user has not selected any image then just disable loading
                    // scrolling the window to top
                    window.scrollTo(0, 0)

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.success(CATEGORY_ADDED_SUCCESSFULLY, {
                        autoClose: 2000
                    })

                    // getting updated categories
                    getCategoriesList()

                    // if current view is create category and it is for a sub category
                    if (currentCategoryView === "createSubCat" && selectedCategory?.length) {
                        //changing url
                        history.push(storeUrl + "/catalog/categories?category=" + selectedCategory + "&mode=edit")
                    }
                }
            }

            // if request is not succeed
            if (addingData.error) {
                console.log(ERROR_WHILE_CREATING_CATEGORY, res)

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(ERROR_WHILE_CREATING_CATEGORY, {
                    autoClose: 2500,
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} addCategory `, err.message)

            // dismissing all the previous toasts first
            toast.dismiss();

            // showing the error message
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    // disabling global loading
                    setGlobalLoading(false)

                    // enabling the button and disabling loading
                    setCategoryBtnLoading(false)
                    setCategorySubmitBtnDisabled(false)
                }
            })
        })
    }

    // update the current category
    const updateCategory = (dataToBeSaved) => {
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        // updating the details from the database
        editCategory(headers, dataToBeSaved).then(res => {
            const updatedData = res.data

            // if successfully created
            if (updatedData.success) {
                if (currentCategoryImage !== null && currentCategoryImage?.value) { // if user has selected any image
                    // data to be saved
                    const dataToBeSaved = {
                        categoryId: parseInt(selectedCategory),
                        image: currentCategoryImage?.value,
                    }

                    const headers = {
                        "Authorization": `Bearer ${authState.commonToken}`,
                        "Api-Token": authState.apiToken,
                        "Access-Token": "",
                        // "Store-Id": authState.storeId,
                    }
                    // network request
                    saveCategoryImageApi(headers, dataToBeSaved).then(res => {
                        // disabling the button and disabling loading
                        setCategoryBtnLoading(false)
                        setCategorySubmitBtnDisabled(false)

                        // disabling global loading
                        setGlobalLoading(false)

                        const resData = res.data

                        // if delete succesfully
                        if (resData.success) {
                            // dismissing all the previous toasts first
                            toast.dismiss();

                            // showing success message
                            toast.success(CATEGORY_UPDATED_SUCCESSFULLY, {
                                autoClose: 2500
                            })

                            // getting updated categories
                            getCategoriesList()
                        }

                        // if some error while deleting
                        if (resData.error) {
                            // dismissing all the previous toasts first
                            toast.dismiss();

                            // showing the error message
                            toast.error(resData.message ?? UNKNOWN_ERROR_OCCURED, {
                                autoClose: 2500,
                            })
                        }

                    }).catch(err => {
                        console.log(`${ERROR_WHILE__NAME} saveCategoryImageApi `, err.message)

                        // dismissing all the previous toasts first
                        toast.dismiss();

                        // showing the error message
                        toast.error(UNKNOWN_ERROR_OCCURED, {
                            autoClose: 2500,
                            onClose: () => {
                                // disabling the button and disabling loading
                                setCategoryBtnLoading(false)
                                setCategorySubmitBtnDisabled(false)

                                // disabling global loading
                                setGlobalLoading(false)
                            }
                        })
                    })
                } else { // if user has not selected any image then just disable loading
                    // scrolling the window to top
                    window.scrollTo(0, 0)

                    // disabling the button and disabling loading
                    setCategoryBtnLoading(false)
                    setCategorySubmitBtnDisabled(false)

                    // disabling global loading
                    setGlobalLoading(false)

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing success message
                    toast.success(CATEGORY_UPDATED_SUCCESSFULLY, {
                        autoClose: 2500
                    })

                    // getting updated categories
                    getCategoriesList()

                }
            }

            // if some error
            if (updatedData.error) {
                console.log(ERROR_WHILE_UPDATING_CATEGORY, res)
                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(ERROR_WHILE_UPDATING_CATEGORY, {
                    autoClose: 2500,
                    onClose: () => {
                        // disabling the button and disabling loading
                        setCategoryBtnLoading(false)
                        setCategorySubmitBtnDisabled(false)

                        // disabling global loading
                        setGlobalLoading(false)
                    }
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} editCategory `, err.message)

            // dismissing all the previous toasts first
            toast.dismiss();

            // showing the error message
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    // disabling global loading
                    setGlobalLoading(false)

                    // enabling the button and disabling loading
                    setCategoryBtnLoading(false)
                    setCategorySubmitBtnDisabled(false)
                }
            })
        })
    }

    // delete the current category
    const removeCategory = (catId) => {
        var confirmation = window.confirm(CONFIRMATION_BEFORE_DELETING_CATEGORY)

        if (confirmation) {
            // enabling the section loading
            setGlobalLoading(true)
            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            // deleting the details from the database
            deleteCategory(headers, catId).then(res => {
                // disabling global loading
                setGlobalLoading(false)

                // enabling the button and disabling loading
                setCategoryBtnLoading(false)
                setCategorySubmitBtnDisabled(false)

                const deletedData = res.data
                // if delete succesfully
                if (deletedData.success) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.success(CATEGORY_DELETED_SUCCESSFULLY, {
                        autoClose: 2500
                    })

                    // getting updated categories
                    getCategoriesList()

                    // reset formik form
                    formik.resetForm()

                    //changing url
                    history.push(storeUrl + "/catalog/categories")
                }

                // if some error while deleting
                if (deletedData.error) {
                    console.log(ERROR_WHILE_DELETING_CATEGORY, res)
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(ERROR_WHILE_DELETING_CATEGORY, {
                        autoClose: 2500,
                    })
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} deleteCategory `, err.message)

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // disabling global loading
                        setGlobalLoading(false)

                        // enabling the button and disabling loading
                        setCategoryBtnLoading(false)
                        setCategorySubmitBtnDisabled(false)
                    }
                })
            })
        }
    }

    // formik hook
    const formik = useFormik({
        initialValues: initialCreateFormValues,
        validationSchema: createFormValidationSchema,
        onSubmit: onCreateFormSubmit,
        enableReinitialize: true
    })

    // handling category name clicked
    const handleAddRootCategoryClick = ev => {
        ev.preventDefault()

        // setting category view name
        setCurrentCategoryView('create')

        // emptying the parent category id
        setParentCategoryId("")

        // emptying the selected category
        setSelectedCategory("")

        // reset formik form
        formik.resetForm()

        //changing url
        history.push(storeUrl + "/catalog/categories?mode=new")
    }

    // handling category name clicked
    const handleAddSubCategoryClick = (ev) => {
        ev.preventDefault()

        // setting category view name
        setCurrentCategoryView('createSubCat')

        // setting parent category id
        setParentCategoryId(selectedCategory)

        // reset formik form
        formik.resetForm()

        //changing url
        history.push(storeUrl + "/catalog/categories?category=" + selectedCategory + "&mode=new")
    }

    // handling delete category
    const handleDeleteCategory = (ev) => {
        ev.preventDefault()

        if (selectedCategory) {
            // enabling global loading
            setGlobalLoading(true)

            // disabling the button and enabling loading
            setCategoryBtnLoading(true)
            setCategorySubmitBtnDisabled(true)

            // calling remove category
            removeCategory(selectedCategory)
        }
    }

    // handling delete category
    const handleExpandCategory = (ev, id) => {
        ev.preventDefault()
        if (id) {
            // find if id is already exists
            let ifIdExists = leftBarExpandedCategories.find(item => item === id)

            // if id exists
            if (ifIdExists) {
                // removing id from the array
                let updatedList = leftBarExpandedCategories.filter(item => item !== id)

                // setting id to the categories array
                setLeftBarExpandedCategories(updatedList)
            } else {
                // setting id to the categories array
                setLeftBarExpandedCategories([...leftBarExpandedCategories, id])
            }
        }
    }

    return (
        <section id="app-categories" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                <div className="app-categories">
                    {/* HEADING WRAPPER */}
                    <div className="app-header-wrapper d-flex mb-2">
                        {/* heading */}
                        <p className="app-heading text-capitalize">Categories</p>
                    </div>

                    {/* CONTENT WRAPPER */}
                    <div className="app-content-container categories-wrapper">
                        {/* top btns */}
                        <div className="cats-all-btns mb-3">
                            <div className="cats-all-btns-inner d-flex flex-wrap align-items-center">
                                {/* add root cat */}
                                <button
                                    type="submit"
                                    className={`st-btn st-btn-primary d-flex align-items-center justify-content-center me-2`}
                                    onClick={handleAddRootCategoryClick}>
                                    <FeatherIcon
                                        icon="plus"
                                        size="15"
                                        className="icon me-2" />
                                    <span>Add Root category</span>
                                </button>

                                {/* add sub cat */}
                                <button
                                    type="submit"
                                    className={`st-btn st-btn-secondary d-flex align-items-center justify-content-center me-2 ${(selectedCategory?.length) ? "" : "disabled"}`}
                                    disabled={(selectedCategory?.length) ? false : true}
                                    onClick={handleAddSubCategoryClick}>
                                    <FeatherIcon
                                        icon="plus"
                                        size="15"
                                        className="icon me-2" />
                                    <span>Add Sub category</span>
                                </button>

                                {/* delete cat */}
                                <button
                                    type="submit"
                                    className={`st-btn st-btn-secondary d-flex align-items-center justify-content-center me-2 ${(selectedCategory?.length) ? "" : "disabled"}`}
                                    disabled={(selectedCategory?.length) ? false : true}
                                    onClick={handleDeleteCategory}>
                                    <FeatherIcon
                                        icon="trash"
                                        size="15"
                                        className="icon me-2" />
                                    <span>Delete category</span>
                                </button>
                            </div>
                        </div>

                        {/* categories main */}
                        <div className="categories-wrapper-inner d-flex flex-wrap">
                            {/* categories list */}
                            <CategoriesLeftBar
                                categoriesLoading={categoriesLoading}
                                categoriesLoadingIndicator={categoriesLoadingIndicator}

                                categoriesPageLoading={categoriesPageLoading}
                                categories={categories}
                                currentCategoryView={currentCategoryView}

                                selectedCategory={selectedCategory}

                                leftBarExpandedCategories={leftBarExpandedCategories}
                                handleExpandCategory={(ev, id) => handleExpandCategory(ev, id)}
                            />

                            {/* categories */}
                            <CategoriesDataView
                                categoriesPageLoading={categoriesPageLoading}
                                formik={formik}
                                currentCategoryView={currentCategoryView}
                                categories={categories}
                                categorySubmitBtnDisabled={categorySubmitBtnDisabled}
                                categoryBtnLoading={categoryBtnLoading}

                                categoryImage={categoryImage}
                                currentCategoryImage={currentCategoryImage}
                                setCurrentCategoryImage={setCurrentCategoryImage}
                                setIsImageDeleted={setIsImageDeleted}
                            />

                        </div>
                    </div>


                </div>
            </Container>
        </section>
    )
}


const getDataFromStore = state => {
    return {
        authState: state.auth
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(Categories)